import RemoveFilterCircleIcon from './RemoveFilterCircleIcon';

export default RemoveFilterCircleIcon;
